
import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/SignatureSection.module.css";
import { useNavigate } from "react-router-dom";

const dishes = [
  {
    title: "Fresh Seafood",
    text: "Daily selected fish and Mediterranean flavors from the Ionian Sea.",
    image:
      "https://images.unsplash.com/photo-1559847844-5315695dadae?q=80&w=1974&auto=format&fit=crop",
  },
  {
    title: "Premium Steaks",
    text: "Perfectly grilled meats prepared with authentic Mediterranean character.",
    image:
      "https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=1974&auto=format&fit=crop",
  },
  {
    title: "Handcrafted Pasta",
    text: "Traditional recipes elevated with modern fine dining presentation.",
    image:
      "https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?q=80&w=1974&auto=format&fit=crop",
  },
  {
    title: "Mediterranean Dessert",
    text: "Elegant handcrafted desserts inspired by authentic Greek tradition.",
    image:
      "https://images.unsplash.com/photo-1565958011703-44f9829ba187?q=80&w=1974&auto=format&fit=crop",
  },
  {
    title: "Luxury Wine Experience",
    text: "A curated collection of wines perfectly paired with every dish.",
    image:
      "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?q=80&w=1974&auto=format&fit=crop",
  },
];

export default function SignatureSection() {

  const navigate = useNavigate();

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev === dishes.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? dishes.length - 1 : prev - 1
    );
  };

  const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect(); // run once (important for performance)
          }
        },
        {
          threshold: 0.25, // triggers when 25% visible
        }
      );
  
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
  
      return () => observer.disconnect();
    }, []);

  return (
    <section
    ref={sectionRef}
    className={`${styles.section} ${isVisible ? styles.active : ""}`}
    id="menu">

      <div className={styles.container}>

        <span className={styles.subtitle}>
          Signature Experience
        </span>

        <h2>Our Featured Dishes</h2>

        <div className={styles.carouselWrapper}>

          <button
            className={styles.arrow}
            onClick={prevSlide}
          >
            ←
          </button>

          <div className={styles.card}>

            <img
              src={dishes[currentIndex].image}
              alt={dishes[currentIndex].title}
            />

            <div className={styles.content}>
              <h3>{dishes[currentIndex].title}</h3>
              <p>{dishes[currentIndex].text}</p>
            </div>

          </div>

          <button
            className={styles.arrow}
            onClick={nextSlide}
          >
            →
          </button>

        </div>

        <div className={styles.dots}>

          {
            dishes.map((_, index) => (

              <span
                key={index}
                className={`${styles.dot} ${
                  currentIndex === index ? styles.activeDot : ""
                }`}
                onClick={() => setCurrentIndex(index)}
              />

            ))
          }

        </div>

        <div className={styles.buttonWrapper}>
          <button
            className={styles.menuButton}
            onClick={() => navigate("/menu")}
          >
            View Full Menu
          </button>
        </div>

      </div>

    </section>
  );
}